import { patchRequest } from 'utils/api/apiRequest'

type Props = {
  cart_item_id: string
  quantity: number
}

export const changeQuantityItem = (data: Props) => patchRequest('/redemption-site/cart/change-quantity', data)
